<template>
  <div class="download-container">
    <span class="save-template">
      <div class="save-template-text">Save template</div>
      <div class="underline"></div>
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      jsonCode: Object
    },
    methods: {
      addDownloadOnClick(el) {
        el.addEventListener('click', () => {
          const data = JSON.stringify(this.jsonCode)
          const blob = new Blob([data], {type: 'text/plain'})
          const e = document.createEvent('MouseEvents'),
            a = document.createElement('a');
          const filename = 'qairn'
          a.download = filename + ".qrn";
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
          e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
          a.dispatchEvent(e)
        })
      },
      handleIcon(el) {
        let svg = new Image()
        let imgSrc = 'src/assets/save-template.svg'
        svg.src = imgSrc
        el.style.backgroundImage = `url(${imgSrc})`
        svg.onload = function() {
          el.style.aspectRatio = svg.width/svg.height
        }
      },
      styleSaveIcon(el) {
        el.style.width = '45px'
        el.style.backgroundRepeat = 'no-repeat'
        el.style.cursor = 'pointer'

        this.handleIcon(el)
      },
      addSaveTemplate() {
        const saveTemplateContainer = this.$el
        const div = document.createElement('div')
        div.setAttribute('id', 'download-data')
        this.styleSaveIcon(div)

        this.addDownloadOnClick(div)

        saveTemplateContainer.insertBefore(div, saveTemplateContainer.firstChild)
      }
    },
    mounted() {
      this.addSaveTemplate()
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/PhoneView/PhoneViewJson.vue